import Toast from "./Toast";

interface PushToastProps {
  state: {
    message: string;
    actionLabel?: string;
    onAction?: () => void;
    onDismiss?: () => void;
    type?:
      | "success"
      | "success-white-bg"
      | "notification"
      | "warning"
      | "error"
      | "info"
      | "neutral";
    autoDismiss?: boolean;
    duration?: number;
    isVisible: boolean;
  };
  onHide: () => void;
}

const PushToast = ({ state, onHide }: PushToastProps) => {
  if (!state.isVisible) return null;

  return (
    <Toast
      message={state.message}
      actionLabel={state.actionLabel}
      onAction={state.onAction}
      onDismiss={() => {
        state.onDismiss?.();
        onHide();
      }}
      type={state.type}
      autoDismiss={state.autoDismiss}
      duration={state.duration}
    />
  );
};

export default PushToast;
